import request from '@/uilt/new-axios.js';
import serverConfig from '@/assets/global/serverConfig';

export const getAccountMonthFullAreaWithAmount = (params) => {
  return request.postJson(
    `${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area-with-amount`,
    params,
  );
};

// 核算月完整范围（GET）：date 所属核算月的起止日期（如"2026-08-26,2026-09-25"），小程序筛选同款；
// 审核列表核算月范围筛选用它把所选月起止换算成任务周期窗口
export const getAccountMonthFullArea = (params) => {
  return request.get(`${serverConfig.msConfigureService}/sysparameter/data/get-account-month-full-area`, params);
};
